export const FORM_POSITION = {
    LEFT: 1,
    RIGHT: 2,
    TOP_LEFT: 3,
    TOP_RIGHT: 4,
    BOTTOM_LEFT: 5,
    BOTTOM_RIGHT: 6,
    CENTER_SMALL: 7,
    CENTER: 8
}
